module.exports = __webpack_public_path__ + "img/8U.afde7342.png";